import { unknownToError } from "@vortex/shared";
import { log } from "./logging";
export default class StyleManager {
    #partials;
    #timeoutId;
    constructor() {
        this.#partials = StyleManager.getDefaultPartials();
    }
    static getDefaultPartials() {
        return [
            { type: "builtin", file: "functions" },
            { type: "builtin", file: "variables" },
            { type: "extendable", key: "variables" },
            { type: "builtin", file: "details" },
            { type: "extendable", key: "details" },
            { type: "builtin", file: "thirdparty" },
            { type: "builtin", file: "desktop" },
            { type: "builtin", file: "style" },
            { type: "extendable", key: "style" },
        ];
    }
    addStylesheet(key, filePath) {
        const partials = StyleManager.addStylesheet(this.#partials, key, filePath);
        this.#partials = partials;
        if (this.#timeoutId !== null) {
            window.clearTimeout(this.#timeoutId);
        }
        this.#timeoutId = window.setTimeout(() => {
            StyleManager.render(this.#partials).catch((err) => {
                log("error", "failed to compile stylesheets", unknownToError(err));
            });
        }, 200);
    }
    async render() {
        await StyleManager.render(this.#partials);
    }
    static async renderDefault() {
        await StyleManager.render(this.getDefaultPartials());
    }
    static addStylesheet(partials, key, filePath) {
        const partial = { type: "extendable", key: key, file: filePath };
        const index = partials.findIndex((partial) => partial.type === "extendable" && partial.key === key);
        if (index !== -1) {
            partials = partials.toSpliced(index, 1, partial);
        }
        else {
            // NOTE(erri120): the "style" stylesheets are always last, we insert new stylesheets before them
            const styleIndex = partials.findLastIndex((partial) => partial.type === "builtin" && partial.file === "style");
            partials = partials.toSpliced(styleIndex, 0, partial);
        }
        return partials;
    }
    static async render(partials) {
        const filePaths = partials
            .filter((partial) => partial.file)
            .map((partial) => partial.file);
        const css = await window.api.compileStylesheets(filePaths);
        this.applyCSS(css);
    }
    static applyCSS(css) {
        const headElements = document.getElementsByTagName("head");
        if (headElements.length === 0)
            return;
        const headElement = headElements[0];
        const newStyleElement = document.createElement("style");
        newStyleElement.id = "theme";
        newStyleElement.innerHTML = css;
        const oldStyleElements = headElement.getElementsByTagName("style");
        for (const oldStyleElement of oldStyleElements) {
            if (oldStyleElement.id !== "theme")
                continue;
            headElement.removeChild(oldStyleElement);
            break;
        }
        headElement.appendChild(newStyleElement);
    }
}
